export default __webpack_public_path__ + "static/media/flag-saudi-arabia.58605c1e.svg";